module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }